import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Country, CountrySort } from '../../lib/types/models/country/country'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCountries(input: PaginationRequest<never, string, Version, CountrySort> = {}) {
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.countries.getAll.url, null), input))
    .get<PaginationResponse<Country>>()
}
